import React from "react";
import CustomInput from "./Custom/CustomInput";
import CustomSelect from "./Custom/CustomSelect";
import CustomDatePicker from "./Custom/CustomDatePicker";
import CustomCheckbox from "./Custom/CustomCheckbox";
import CustomRadio from "./Custom/CustomRadio";
import CustomTextEditor from "./Custom/CustomTextEditor";
import ToggleButton from "./ToggleButton";
import TextArea from "./TextArea";
// import FileUpload from "./FileUpload";
import CustomFileInput from "./Custom/CustomFileInput";
import CustomPhoneInput from "./Custom/CustomPhoneInput";
import ToggleInput from "./ToggleInput";
import DynamicSelect from "./DynamicSelect/DynamicSelect";
import CustomEmail from "./Custom/CustomEmail";
import CustomPhone from "./Custom/CustomPhone";
import CustomToggle from "./Custom/CustomToggle";
import CustomPassword from "./Custom/CustomPassword";
import CustomMonthPicker from "./Custom/CustomMonthPicker";
import CustomToMailIds from "./Custom/CustomToMailIds";
import CustomMultiSelect from "./Custom/CustomMultiselect";
import CustomRadioSelect from "./Custom/CustomRadioSelect";
import CustomFileInputButton from "./Custom/CustomFileInputButton";
import FileUploadOne from "./FileUploadOne";
import CustomSelectNew from "./Custom/CustomSelectNew";
import CustomTags from "./Custom/CustomTags";
import CustomSelectWithDefault from "./Custom/CustomSelectWithDefault";

const FormFieldSet = ({
  type = "text", //text, select, search, radio, checkbox, datepicker,ds
  title = "Title",
  noTitle = false,
  placeholder = "Placeholder",
  size = "md",
  rounded = "rounded",
  value = "",
  values = [],
  blockDates = [], // array of objects of form and to , ex : { from: "2025-11-15", to: "2025-11-20" },
  code, //selected country code
  onChange,
  options = [
    { label: "A", value: "a" },
    { label: "B", value: "b" },
    { label: "C", value: "c" },
  ],
  multiple = false,
  style, // for select multiple
  maxDate,
  minDate = new Date("1900-01-01"),
  showSearch = false, //
  searchValue,
  onSearch,
  showTime = false,
  noGenerate = false,
  showDropdown = true,
  onClose,
  showButton = false,
  showViewButton = false,
  onViewClick,
  alertName,
  error = false,
  icon = false,
  required = false,
  isChecked,
  disabled,
  label,
  rows = 2,
  name,
  accept,
  labelPosition,
  // subtitle,
  leftText,
  rightText,
  leftIcon,
  rightIcon,
  refData,
  handleScroll,
  keyname,
  parentValue, // Add this prop for citiesState
  parentId, // Add this prop for citiesState
  ret,
  refCollection,
  onSelectItem,
  placementUiid,
  entityType,
  list,
  showNames = false,
  filters,
  passwordFormat,
  maxCount,
  userList,
  showSelectAll = true,
  color = "primary",
  onFileSelect,
  cardHeight,
  cardWidth,
  files,
  shadow,
  onKeyDown,
  onPaste,
  showBadges,
  badgeSize,
  suggestionsList = [],
  maxLength = 300,
  onFocus,
  defaultOption,
  defaultValue,
  onSetDefault,
  showLogo = false,
  allowedPattern,
  validate,
  showClearButton,
}) => {
  const renderField = () => {
    switch (type) {
      case "text":
      case "search":
        return (
          <CustomInput
            placeholder={placeholder}
            size={size}
            onFocus={onFocus}
            rounded={rounded}
            value={value}
            onChange={onChange}
            disabled={disabled}
            shadow={shadow}
            onKeyDown={onKeyDown}
            onPaste={onPaste}
            suggestionsList={suggestionsList}
          />
        );

      case "password":
        return (
          <CustomPassword
            placeholder={placeholder}
            size={size}
            noGenerate={noGenerate}
            rounded={rounded}
            value={value}
            onChange={onChange}
            disabled={disabled}
            passwordFormat={passwordFormat}
            shadow={shadow}
          />
        );
      case "toMailIds":
        return (
          <CustomToMailIds
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            disabled={disabled}
            maxCount={maxCount}
            userList={userList}
            shadow={shadow}
          />
        );
      case "tags":
        return (
          <CustomTags
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            disabled={disabled}
            maxCount={maxCount}
            suggestions={suggestionsList}
            shadow={shadow}
            validate={validate}
            allowedPattern={allowedPattern}
          />
        );
      case "select":
        return (
          <CustomSelectNew
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            options={options}
            selected={value}
            onChange={onChange}
            showSearch={showSearch}
            showButton={showButton}
            alertName={alertName}
            icon={icon}
            disabled={disabled}
            // subtitle={subtitle}
            refData={refData}
            handleScroll={handleScroll}
            keyname={keyname}
            searchValue={searchValue}
            onSearch={onSearch}
            onClose={onClose}
            multiple={multiple}
            style={style}
            shadow={shadow}
            showBadges={showBadges}
            badgeSize={badgeSize}
            showClearButton={showClearButton}
          />
        );
      case "selectDefault":
        return (
          <CustomSelectWithDefault
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            options={options}
            selected={value}
            onChange={onChange}
            showSearch={showSearch}
            showButton={showButton}
            alertName={alertName}
            icon={icon}
            disabled={disabled}
            refData={refData}
            handleScroll={handleScroll}
            keyname={keyname}
            searchValue={searchValue}
            onSearch={onSearch}
            onClose={onClose}
            multiple={multiple}
            style={style}
            shadow={shadow}
            showBadges={showBadges}
            badgeSize={badgeSize}
            // New props
            defaultValue={defaultValue}
            onSetDefault={onSetDefault}
            showLogo={showLogo}
          />
        );
      case "multiSelect":
        return (
          <CustomMultiSelect
            placeholder={placeholder}
            options={options}
            value={value}
            onChange={onChange}
            showViewButton={showViewButton}
            onViewClick={onViewClick}
            disabled={disabled}
            style={style}
            showSelectAll={showSelectAll}
            showSearch={showSearch}
            shadow={shadow}
          />
        );
      case "radioSelect":
        return (
          <CustomRadioSelect
            placeholder={placeholder}
            options={options}
            value={value}
            onChange={onChange}
            disabled={disabled}
            showSearch={showSearch}
            shadow={shadow}
          />
        );

      case "jobTitle":
      case "atsJobTitle":
      case "financeManager":
      case "hrManager":
      case "immigrationManager":
      case "countriesUsAndCanada":
      case "countries":
      case "documentTypes":
      case "eVerifiedBy":
      case "allClientsList":
      case "employees":
      case "employeesConsultantFullNames":
      case "states":
      case "cities":
      case "citiesState":
      case "atscitiesState":
      case "netTerm":
      case "clientCategory":
      case "jobTerminationNotice":
      case "contactType":
      case "roleType":
      case "employeeClients":
      case "employeePlacements":
      case "employeesSorted":
      case "employeesSortedNonBillable":
      case "employeesSortedWithoutRef":
      case "placementsForTimesheetsAdd":
      case "allVendorsList":
      case "placements":
      case "placementsWithEmployeeName":
      case "placementsForPayConfigDropDown":
      case "allClientsSorted":
      case "placementsList":
      case "allPayProfiles":
      case "clientsWithPlacements":
      case "allEmployees":
      case "allEmployees4Type":
      case "employeeWithPlacement":
      case "deductions":
      case "jobRoles":
      case "expensesTypes":
      case "paymentMethods":
      case "depositTo":
      case "allTimesheetClients":
      case "allInvoiceClients":
      case "industry":
      case "atsRoles":
      case "workforceRoles":
      case "benchsalesRoles":
      case "users":
      case "bdmAndRecruiters":
      case "bdmAndRecruitersUsers":
      case "AllBdmRecruiters":
      case "AllRecruiters":
      case "onlyBDMUsers":
      case "bdmManagers":
      case "bdmUsers":
      case "emailSourceAccounts":
      case "emailSourceAccountsBs":
      case "candidateAuthEmails":
      case "templates":
      case "getCampaignAccounts":
      case "getWorkSpaceUsers":
      case "companiesSearch": //added for recruiment/jobs/alljobs
      case "allCompanies":
      case "employeesSortedOnboarding":
      case "allUsers":
      case "getJobBoardUsers":
      case "getJobBoardUsersBs":
      case "getCandidateAuthEmailsBs":
      case "clientsSortedOnboarding":
      case "allVendorsListOnboarding":
      case "allPdfTemplatesNames":
      case "usersForEonboarding":
      case "checklistsWithEntityFilter":
      case "bs_email_templates":
      case "bs_candidate_email_templates":
      case "bs_company_name":
      case "aiCallAssistants":
        return (
          <DynamicSelect
            type={type}
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            options={options}
            selected={value}
            onChange={onChange}
            showSearch={showSearch}
            showButton={showButton}
            alertName={alertName}
            icon={icon}
            disabled={disabled}
            // subtitle={subtitle}
            refData={refData}
            handleScroll={handleScroll}
            keyname={keyname}
            searchValue={searchValue}
            onSearch={onSearch}
            onClose={onClose}
            multiple={multiple}
            parentValue={parentValue}
            parentId={parentId} // Add this prop for citiesState
            ret={ret}
            refCollection={refCollection}
            onSelectItem={onSelectItem}
            placementUiid={placementUiid}
            entityType={entityType}
            showNames={showNames}
            filters={filters}
            shadow={shadow}
            showClearButton={showClearButton}
          />
        );
      case "email":
        return (
          <CustomEmail
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            value={value}
            onChange={onChange}
            multiple={multiple}
            disabled={disabled}
            shadow={shadow}
          />
        );
      case "textEditor":
        return (
          <CustomTextEditor
            placeholder={placeholder}
            initialContent={value}
            onContentChange={onChange}
            disabled={disabled}
          />
        );

      case "datepicker":
      case "datepickerRange":
        return (
          <CustomDatePicker
            range={type === "datepickerRange"}
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            selected={value}
            showTime={showTime}
            onChange={onChange}
            // Optional props:
            // maxDate={new Date("2025-12-31")}
            // minDate={new Date("2024-01-01")}
            maxDate={maxDate}
            minDate={minDate}
            disabled={disabled}
            shadow={shadow}
            blockDates={blockDates}
            defaultOption={defaultOption}
            showDropdown={showDropdown}
          />
        );
      case "monthpicker":
      case "monthpickerRange":
        return (
          <CustomMonthPicker
            range={type === "monthpickerRange"}
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            selected={value}
            onChange={onChange}
            maxDate={maxDate}
            minDate={minDate}
            disabled={disabled}
            shadow={shadow}
          />
        );
      case "checkbox":
        return (
          <CustomCheckbox
            size={size}
            options={options}
            selectedValues={values}
            onChange={onChange}
            multiple={multiple} // Change to false for single selection
            disabled={disabled}
            list={list}
          />
        );
      case "toggleNew":
        return (
          <CustomToggle
            value={value}
            options={options}
            disabled={disabled}
            onChange={onChange}
            size={size}
          />
        );
      case "radio":
        return (
          <CustomRadio
            size={size}
            options={options}
            selectedValue={value}
            onChange={onChange}
            //multiple={multiple} // Change to false for single selection
            name={name}
            disabled={disabled}
            list={list}
          />
        );
      case "toggle":
        return (
          <ToggleButton
            size={size}
            isChecked={isChecked}
            onChange={onChange}
            label={label}
            disabled={disabled}
            labelPosition={labelPosition}
          />
        );
      case "textArea":
        return (
          <TextArea
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            value={value}
            onChange={onChange}
            rows={rows}
            disabled={disabled}
            shadow={shadow}
            maxLength={maxLength}
          />
        );
      case "file":
        return (
          <CustomFileInput
            size={size}
            onChange={onChange}
            multiple={multiple}
            accept={accept}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            shadow={shadow}
          />
        );
      case "fileButton":
        return (
          <CustomFileInputButton
            title={title}
            size={size}
            onChange={onChange}
            multiple={multiple}
            accept={accept}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            color={color}
          />
        );

      case "phone":
        return (
          // <CustomPhoneInput
          //   placeholder={placeholder}
          //   size={size}
          //   rounded={rounded}
          //   value={value}
          //   selectedCountryCode={code}
          //   onChange={(fullValue, details) => {
          //     // Pass both the full value and details to the parent onChange
          //     onChange(fullValue, details);
          //   }}
          // />
          <CustomPhoneInput
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            value={value}
            selectedCountryCode={code}
            onChange={(fullValue, details) => {
              // Pass both the full value and the details to parent's onChange
              onChange(fullValue, details);
            }}
            disabled={disabled}
            shadow={shadow}
          />
        );
      case "phoneNew":
        return (
          <CustomPhone
            value={values}
            onChange={onChange}
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            selectedCountryCode={code}
            disabled={disabled}
            multiple={multiple}
            shadow={shadow}
          />
        );
      case "toggleInput":
        return (
          <ToggleInput
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            size={size}
            rounded={rounded}
            disabled={disabled}
            leftText={leftText}
            rightText={rightText}
            icon={icon}
            leftIcon={leftIcon}
            rightIcon={rightIcon}
          />
        );
      case "fileupload":
        return (
          <FileUploadOne
            onFileSelect={onFileSelect}
            cardHeight={cardHeight}
            cardWidth={cardWidth}
            files={files}
          />
        );
      case "number":
        return (
          <CustomInput
            type="number"
            placeholder={placeholder}
            size={size}
            rounded={rounded}
            value={value}
            onChange={onChange}
            disabled={disabled}
            shadow={shadow}
            onKeyDown={onKeyDown}
          />
        );

      default:
        return null; // You can render a default component if needed
    }
  };

  return (
    <div className="flex flex-col">
      {!noTitle && (
        <div className="flex justify-between items-center mb-0.5 min-h-[18px]">
          <div className="text-[12px] font-medium">
            <label>
              {title}
              {required ? <span className="text-red-600">*</span> : ""}
            </label>
          </div>
          {maxLength && type === "textArea" && (
            <div className="text-[12px] text-gray-500">
              <span
                className={
                  value.length >= maxLength ? "text-red-600 font-medium" : ""
                }
              >
                {value.length}
              </span>
              <span className="text-gray-400">/{maxLength}</span>
            </div>
          )}
        </div>
      )}
      <div className="min-h-[39px] flex items-center">{renderField()}</div>
      <div>
        {error && <span className="text-danger-300 text-xs">{error}</span>}
      </div>
    </div>
  );
};

export default FormFieldSet;
